const CandlePackSelector = {
    maximumCandles: 2,
    selectedCandles: [],
    init() {
        this.addToCartButton = document.querySelector('[data-add-to-cart-pack]');
        this.clearAllButton = document.querySelector('[data-clear-all-pack]');
        this.firstCandleSelected = document.querySelector('[data-first-candle-selected]');
        this.secondCandleSelected = document.querySelector('[data-second-candle-selected]');
        this.candles = document.querySelectorAll('.product-grid--custom_column');
        this.selectButtons = document.querySelectorAll('[data-select-candle]');

        this.bindEvents();
    },
    bindEvents() {
        this.selectButtons.forEach((button) =>
            button.addEventListener('click', (event) => {
                event.stopPropagation();
                const candleColumn = button.closest('.product-grid--custom_column-wrapper').querySelector('.product-grid--custom_column');
                if (candleColumn) {
                    this.toggleCandleSelection(candleColumn);
                }
            })
        );

        this.clearAllButton.addEventListener('click', () => this.clearAllCandles());
        this.addToCartButton.addEventListener('click', () => this.addPackToCart());
    },
    toggleCandleSelection(candle) {
        const candleName = candle.dataset.candleName;
        const buttons = candle.closest('.product-grid--custom_column-wrapper').querySelectorAll('[data-select-candle]');

        if (candle.classList.contains('selected-candle')) {
            candle.classList.remove('selected-candle');
            this.selectedCandles = this.selectedCandles.filter((name) => name !== candleName);
            buttons.forEach(button => button.querySelector('.subheading-custom').textContent = "Select candle");
        } else if (this.selectedCandles.length < this.maximumCandles) {
            candle.classList.add('selected-candle');
            this.selectedCandles.push(candleName);
            buttons.forEach(button => button.querySelector('.subheading-custom').textContent = "Deselect candle");
        }

        this.updateUI();
    },
    updateUI() {
        const [first, second] = this.selectedCandles;

        this.firstCandleSelected.textContent = first || 'Select below';
        this.secondCandleSelected.textContent = first && !second ? 'Select below' : (second || 'Not selected');

        this.firstCandleSelected.classList.toggle('selected-candle-name', !!first);
        this.secondCandleSelected.classList.toggle('selected-candle-name', !!second);

        this.candles.forEach((candle) => {
            candle.classList.toggle('disabled-candle', this.selectedCandles.length >= this.maximumCandles && !candle.classList.contains('selected-candle'));
        });

        this.addToCartButton.disabled = this.selectedCandles.length < this.maximumCandles;
        this.clearAllButton.classList.toggle('hidden', this.selectedCandles.length === 0);
    },
    clearAllCandles() {
        this.selectedCandles = [];
        this.candles.forEach((candle) => {
            candle.classList.remove('selected-candle', 'disabled-candle');
            const buttons = candle.closest('.product-grid--custom_column-wrapper').querySelectorAll('[data-select-candle]');
            buttons.forEach(button => {
                button.querySelector('.subheading-custom').textContent = "Select candle";
            });
        });
        this.updateUI();
    },
    getCandleVariantId(candleName) {
        const candle = document.querySelector(`[data-candle-name="${candleName}"]`);
        return candle ? candle.getAttribute('data-candle-id') : null;
    },
    addPackToCart() {
        const giftProductId = document.querySelector('[data-gift-product]').getAttribute('data-gift-product');

        if (this.selectedCandles.length < this.maximumCandles) {
            return;
        }

        const firstCandleVariantId = this.getCandleVariantId(this.selectedCandles[0]);
        const secondCandleVariantId = this.getCandleVariantId(this.selectedCandles[1]);

        const items = [
            {
                id: parseInt(giftProductId),
                quantity: 1,
                properties: {
                    "Candle 1": this.selectedCandles[0],
                    "_candle_1_variant_id": firstCandleVariantId,
                    "Candle 2": this.selectedCandles[1],
                    "_candle_2_variant_id": secondCandleVariantId
                }
            }
        ];

        fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
        })
            .then((response) => {
                if (response.ok) {
                    window.location.href = "/cart";
                } else {
                    return response.json().then((data) => {
                        console.error('Error adding to cart:', data);
                    });
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
    }
};

document.addEventListener('DOMContentLoaded', () => CandlePackSelector.init());

if (window.innerWidth >= 1024) {
    document.addEventListener("DOMContentLoaded", function () {
        const stickyElement = document.querySelector(".pack-selection-shopify-section");
        const container = document.querySelector(".pack-selection-section");

        if (stickyElement && container) {
            const stickyOffset = stickyElement.offsetTop;

            window.addEventListener("scroll", function () {
                if (window.scrollY >= stickyOffset) {
                    container.classList.add("sticky-active");
                } else {
                    container.classList.remove("sticky-active");
                }
            });
        }
    });
}
